(function() {
'use strict';

angular
    .module('transfers')
    .controller('Resorts', Resorts);

function Resorts(searchUnitService, $window) {
    this.setResort = function(item) {
        searchUnitService.setResort(item);

        // Timer avoids infinite digest loops
        setTimeout(() => {
            $window.history.back();
        }, 0);
    };
}
})();
